import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sercret-runes',
  templateUrl: './sercret-runes.component.html',
  styleUrls: ['./sercret-runes.component.css']
})
export class SercretRunesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
